import { prepareHeaders } from "./";
import cincolabdataEndpoints from "./cincolabdata.endpoints";

import type { Event } from "./events";
import type { LocalizedField } from "./types";

export const ONLINE_EVENT_KEY =
  "FORD_MODEL_E_DIGITAL_ACTIVATION-ONLINE" as const;

export interface FieldChoice {
  value: string;
  label: LocalizedField;
}

export interface DisplayCondition {
  field_key: string;
  condition: string;
  value: string;
}

export interface Field {
  key: string;
  enabled: boolean;
  optional: boolean;
  hidden: boolean;
  type: string;
  choices?: FieldChoice[];
  display_conditions: DisplayCondition[];
  label: LocalizedField;
  answer?: string | null;
}

export interface PublicFormInstance {
  key: string;
  title: LocalizedField;
  description: LocalizedField;
  footer: LocalizedField;
  image_url: LocalizedField;
  fields: Field[];
  event: Event;
  region: string;
  activation_id: number;
  email_field_position: number;
  default_locale: string;
}

/**
 * Retrieves a form instance from the server.
 * @param instance_key - The key of the form instance to retrieve.
 * @returns A promise that resolves to the form instance if found, or null if not found.
 */
export const getFormInstance = async (
  instance_key: string,
): Promise<PublicFormInstance | null> => {
  const response = await fetch(
    cincolabdataEndpoints.public.survey(instance_key),
    {
      method: "GET",
      headers: prepareHeaders(),
      mode: "cors",
      redirect: "follow",
    },
  );

  const data = await response.json();

  if (response.status !== 200) {
    return null;
  }
  return data;
};

export const isValidEmail = (email: string) => {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

  return emailRegex.test(email.toLowerCase().trim());
};
